// Module
var code = "<div id=\"V-6207D3E1-CF91-4919-8ECA-2CAAA0AED0D3\" data-b-event-click=\"{Binding toggle}\" data-b-event-bindercomponentspopupignorewindowclick=\"{Binding ignoreWindowClick}\"> <div data-b-component=\"popup\" class=\"v-6207d3e1-cf91-4919-8eca-2caaa0aed0d3-popup\" data-b-comp-preferredwidth=\"{Binding preferredwidth}\"> </div> </div> ";
// Exports
export default code;